// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  padding-left: 20px;
  padding-right: 20px;
  flex: 1 1;
}

@media(max-width: 400px) {
  .dashboard-container h1 {
    font-size: 1.5em;
  }
}

.puzzle-table-header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  border-bottom: 2px solid #ccc;
  padding-bottom: 5px;
}

.puzzle-table-header-title {
  flex-grow: 1;
  text-align: center;
}

.puzzle-table-header-create-puzzle {
  margin-left: auto;
  background-color: #4CAF50;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.puzzle-table-header-container-spacer {
  flex-grow: 1;
}
`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Authenticated/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".dashboard-container {\n  padding-left: 20px;\n  padding-right: 20px;\n  flex: 1;\n}\n\n@media(max-width: 400px) {\n  .dashboard-container h1 {\n    font-size: 1.5em;\n  }\n}\n\n.puzzle-table-header-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  border-bottom: 2px solid #ccc;\n  padding-bottom: 5px;\n}\n\n.puzzle-table-header-title {\n  flex-grow: 1;\n  text-align: center;\n}\n\n.puzzle-table-header-create-puzzle {\n  margin-left: auto;\n  background-color: #4CAF50;\n  color: white;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.puzzle-table-header-container-spacer {\n  flex-grow: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
